import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: the intents the UI dispatches for the saga to act on. Kept
 * out of the slice's reducers: they trigger side effects (network calls), not
 * state transitions (the saga owns the resulting `*Started/Failed/…` transitions).
 *
 * `backToCredentials`, field/digit edits and `resetForm` are NOT signals; they
 * are pure state transitions, so they live as slice reducers.
 */

/** Submit the credentials draft (step 1). */
export const credentialsSubmitted = createAction('login/credentialsSubmitted');

/**
 * Submit the OTP code (step 2). `rememberMe` is a page-owned preference (not in
 * the store), carried in the payload; mirroring reset-password passing its URL
 * token via the action rather than storing it.
 */
export const otpSubmitted = createAction<{ rememberMe: boolean }>('login/otpSubmitted');

/** Ask the backend to re-send the OTP code for the current session token. */
export const otpResendRequested = createAction('login/otpResendRequested');
